"use strict";
exports.__esModule = true;
exports.KILL_SWITCH = void 0;
exports.KILL_SWITCH = {
    BODY: 'Our team is working to resolve the issue. Please try again later.',
    HEADER: 'We’re experiencing technical issues'
};
